import { FC } from 'react';

import { noRowsUpload, RadioButtonCellRenderer, Table } from 'common/components';
import { convertTreeToFlatData } from 'common/utils/table';

import CheckboxCellRenderer from '../custom-cell-renderers/checkbox-cell-renderer/CheckboxCellRenderer';
import './HierarchyList.scss';

type HierarchyListProps = {
    isNoDataVisible: boolean;
    data: any;
    columnDefs: any;
    className?: string;
    selectorType?: string;
    handleScroll?: () => void;
};

const HierarchyList: FC<HierarchyListProps> = ({
    isNoDataVisible,
    data,
    columnDefs,
    className,
    selectorType,
    handleScroll
}: HierarchyListProps) => {
    return (
        <div className={`add-sub-category-data-list-container ${className}`}>
            <Table
                suppressRowClickSelection
                suppressCellSelection
                columnDefs={columnDefs}
                rowData={convertTreeToFlatData(data, 0, -1)}
                fetchNextDataSet={handleScroll}
                rowDragManaged={true}
                noRowsTemplate={noRowsUpload}
                isNoRowsOverlayVisible={isNoDataVisible}
                preventColumnFit
                frameworkComponents={
                    selectorType !== 'checkbox'
                        ? {
                              radioButtonCellRenderer: RadioButtonCellRenderer
                          }
                        : {
                              CheckboxCellRenderer: CheckboxCellRenderer
                          }
                }
            />
        </div>
    );
};

export default HierarchyList;
